<app-edit-detail-project #edit></app-edit-detail-project>
<app-indicators [idleader]="idleader" #indicators></app-indicators>
<app-project-finish-assignment  #finishAssign></app-project-finish-assignment>
<ng-container *ngIf="projectDetailsDto.length == 0">
    <div class="text-center text-white">
        <h2 class="text-white px-5 mt-5">Sin Datos</h2>
        <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
    </div>
</ng-container>

<div class="mt-4">
    <h4 class="text-start text-white px-5 mt-5 mb-3">{{ projectDetailsDto['projectName'] }} / DETALLE DE PROYECTO</h4>
    <h4 *ngIf="projectDetailsDto.length == 0" class="text-start text-white px-5 mt-5 mb-3">PROYECTO / DETALLE DE
        PROYECTO</h4>
    <div class="ms-5 me-5">
        <div class="row">
            <!--tarjetas de detalle -->
            <div class="col-md-6 col-lg-3 mb-4 ">
                <div class="card border-0 rounded-1  text-white color-grafi-list">
                    <div class="card-body">
                        <div class="card-innerBody d-flex align-items-center">
                            <div class="card-icon text-light">
                                <i class="fa-solid fa-hand"></i>
                            </div>
                            <div class="ms-auto">
                                <p class="card-label text-end text-muted">CU Est</p>
                                <h4 *ngIf="!isValid(projectDetailsDto['estimatedCu'])" class="card-text text-end ">{{
                                    projectDetailsDto['estimatedCu'] }}</h4>
                                <h4 *ngIf="isValid(projectDetailsDto['estimatedCu'])" class="card-text text-end ">0</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-3 mb-4 ">
                <div class="card border-0 rounded-1 text-white color-grafi-list">
                    <div class="card-body">
                        <div class="card-innerBody d-flex align-items-center">
                            <div class="card-icon text-light">
                                <i class="fa-solid fa-clock"></i>
                            </div>
                            <div class="ms-auto">
                                <p class="card-label text-end text-muted">PF</p>
                                <h4 *ngIf="!isValid(projectDetailsDto['pf'])" class="card-text text-end ">{{
                                    projectDetailsDto['pf'] }}</h4>
                                <h4 *ngIf="isValid(projectDetailsDto['pf'])" class="card-text text-end">0</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-3 mb-4">
                <div class="card border-0 rounded-1 text-white color-grafi-list">
                    <div class="card-body">
                        <div class="card-innerBody d-flex align-items-center">
                            <div class="card-icon text-light">
                                <i class="fa-solid fa-user-clock"></i>
                            </div>
                            <div class="ms-auto">
                                <p class="card-label text-end text-muted">HH</p>
                                <h4 *ngIf="!isValid(projectDetailsDto['hh'])" class="card-text text-end ">{{
                                    projectDetailsDto['hh']}}</h4>
                                <h4 *ngIf="isValid(projectDetailsDto['hh'])" class="card-text text-end ">0</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-3 mb-4">
                <div class="card border-0 rounded-1 text-white color-grafi-list">
                    <div class="card-body">
                        <div class="card-innerBody d-flex align-items-center">
                            <div class="card-icon text-light">
                                <i class="fa-solid fa-wallet"></i>
                            </div>
                            <div class="ms-auto">
                                <p class="card-label text-end text-muted">UF</p>
                                <h4 *ngIf="!isValid(projectDetailsDto['uf']) " class="card-text text-end ">
                                    {{projectDetailsDto['uf']}}</h4>
                                <h4 *ngIf="isValid(projectDetailsDto['uf'])" class="card-text text-end ">0</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Detalles proyecto -->
        <div>
            <div class="row mt-5">
                <div class="col-12 col-xl-12 mb-4">
                    <div class="card border-0 rounded-1 p-2 text-white color-grafi-list">
                        <div class="card-title mb-1 p-3 d-flex">
                            <h6>{{ projectDetailsDto['projectName'] }}</h6>
                        </div>
                        <div class="card-body">
                            <p class="card-label text-start font-size-14 text-lightning">{{
                                projectDetailsDto['projectAlias'] }}</p>
                        </div>
                        <div class="card-footer d-flex text-lightning font-size-12">
                            <p class="me-2 font-size-12 fw-lighter">
                                <i class="fa-solid fa-calendar"></i>
                                {{projectDetailsDto['startDate']}}
                            </p>
                            <p class="me-2 font-size-12 fw-lighter font-size-12">
                                <i class="fa-solid fa-calendar"></i>
                                {{projectDetailsDto['endDate']}}
                            </p>
                            <button class="badge rounded-pill btn btn-outline-light  font-size-12">
                                <i class="fa-solid fa-book"></i>
                                Bitácora
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!--Tabla Equipo de Desarrallo -->
            <div class="row mt-5">
                <div class="row justify-content-between">
                    <div class="col-6 col-xl-6">
                        <h5 class="text-start text-white mt-1 mb-3 h4">Equipo de desarrollo</h5>
                    </div>
                    <div class="col-6 col-xl-6 text-end">
                        <ng-container *ngIf="permisoOptionAdminTeam == true">
                            <button (click)="crearEquipo()" class="badge rounded-pill btn btn-outline-light " style="font-size: 14px;">
                                <i class="fa-solid fa-plus m-1"></i>
                                <span class="m-1" >Administrar Equipo</span>
                            </button>
                        </ng-container>
                    </div>
                </div>
                        <div class="container-fluid">
                            <div class="backgroundTable">
                        
                            <div class="row">
                                <div class="col-6 filterDatatable">
                                    <div class="col-md-6 text-left text-white">
                                        <h6 class="form-control-table custom-select-info">Equipo asignado</h6>
                                    </div>
                                </div>
                            </div>
                        <div class="card-body">
                            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"  class="componente-importantes componente-importantes-from-popup">
                                <ng-container *ngIf="developersTeam == null || developersTeam.length == 0">
                                    <div class="text-center text-white">
                                        <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                        <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="developersTeam != null && developersTeam.length != 0">
                                    <thead>
                                        <tr>
                                            <th class="text-center">Avatar</th>
                                            <th class="text-center">Nombre</th>
                                            <th class="text-center">Cargo</th>
                                            <th class="text-center">Estado Asignación</th>
                                            <th class="text-center">% Asignación</th>
                                            <th class="text-center">Fecha inicio asignación</th>
                                            <th class="text-center">Fecha fin asignación</th>
                                           
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of developersTeam">
                                           
                                            <td class="text-center">

                                                <div class="d-flex justify-content-center bd-highlight mb-2">
                                                    <div class="p-2 bd-highlight">
                                                        <img src={{item.url}} class="img-fluid badge-img-radio" alt=""> 
                                                    </div>
                                                  </div>
                                       
                                          
                                            </td>

                                            <td class="font-size-12">{{item.name}}</td>
                                            <td class="text-center">
                                                <div class="d-flex justify-content-center bd-highlight mb-2">
                                                    <div class="p-2 bd-highlight">
                                                        <span
                                                            class="badge rounded-pill text-bg-blue-grey p-2 font-size-12" style="width: 6rem !important;" >{{item.type}}</span>
                                                    </div>

                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div class="d-flex justify-content-center bd-highlight mb-2">
                                                    <div class="p-2 bd-highlight">
                                                        <span *ngIf="item.status === 1" 
                                                            class="badge rounded-pill text-bg-success font-size-12 p-2" style="width: 6rem !important;" >vigente</span>
                                                        <span *ngIf="item.status === 2"
                                                            class="badge rounded-pill text-bg-warning font-size-12 p-2" style="width: 6rem !important;" >pendiente</span>
                                                        <span *ngIf="item.status === 3"
                                                            class="badge rounded-pill text-bg-alert font-size-12 p-2" style="width: 6rem !important;" >excedido</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td *ngIf="item.percentage == 100" class="text-success font-size-12">{{item.percentage}}%
                                            </td>
                                            <td *ngIf="item.percentage < 100" class="text-warning font-size-12">{{item.percentage}}%
                                            </td>
                                            <td class="text-center">
                                                <div class="d-flex justify-content-center bd-highlight mb-2">
                                                    <div class="p-2 bd-highlight">
                                                        <span
                                                            class="badge rounded-pill text-bg-info text-white font-size-12 p-2" style="width: 6rem !important;">{{item.dateStart}}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span
                                                    class="badge rounded-pill text-bg-orange font-size-12 p-2" style="width: 6rem !important;" >{{item.dateEnd}}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </ng-container>
                            </table>


                        </div>
                    </div>

                </div>
            </div>

            <!--Indicadores Semanales--> -->
            
            <div class="row  mt-5">
                <div class="row justify-content-between">
                    <div class="col-6 col-xl-6">
                        <h5 class="text-start text-white mt-1 mb-3 h4">Indicadores Semanales</h5>
                    </div>
                    <div class="col-6 col-xl-6 text-end">
                        <button (click)="indicators.open(idleader)" class="badge rounded-pill btn btn-outline-light"  style="font-size: 14px;">
                            <i class="fa-solid fa-plus m-1"></i>
                            <span class="m-1">Crear indicador</span>
                        </button>
                    </div>
                </div>

                <div class="col-12 col-xl-6 mb-4  d-flex align-items-stretch" >
                    <div class="backgroundTable ">
                       <div class="row">
                                <div class="col-6 filterDatatable">
                                    <div class="text-white">
                                        <h5 class="form-control-table custom-select-info mt-1">Semana Anterior</h5>
                                    </div>
                                </div>
                            </div>
                        <div class="card-body ">
                            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"  class="componente-importantes componente-importantes-from-popup">
                                        <ng-container *ngIf="listLastWeek == null || listLastWeek.length == 0">
                                            <div class="text-center text-white">
                                                <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                                <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="listLastWeek != null && listLastWeek.length != 0">
                                            <thead>
                                                <tr>
                                                    <th>Colaborador</th>
                                                    <th>Gestión</th>
                                                    <th>Subv</th>
                                                    <th>Trabajo en equipo</th>
                                                </tr>
                                            </thead>
                                            <tbody class="align-middle">
                                                <tr>
                                                    <td>{{transformName(listLastWeek[0].name)}}</td>
                                                    <td *ngFor="let item of listLastWeek">
                                                        <div *ngIf="item.idindicator == 1">
                                                            <span *ngIf="item.value == 3" class="badge-danger">
                                                                <i class="fa-solid fa-xmark text-white pt-1"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 2" class="badge-warning">
                                                                <i class="fa-solid fa-info text-white pt-1"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 1" class="badge-success">
                                                                <i class="fa-solid fa-check text-white pt-1"></i>
                                                            </span>
                                                        </div>
                                                        <div *ngIf="item.idindicator == 2">
                                                            <span *ngIf="item.value == 3" class="badge-danger">
                                                                <i class="fa-solid fa-xmark text-white pt-1"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 2" class="badge-warning">
                                                                <i class="fa-solid fa-info text-white"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 1" class="badge-success">
                                                                <i class="fa-solid fa-check text-white pt-1"></i>
                                                            </span>
                                                        </div>
                                                        <div *ngIf="item.idindicator == 3">
                                                            <span *ngIf="item.value == 3" class="badge-danger">
                                                                <i class="fa-solid fa-xmark text-white pt-1"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 2" class="badge-warning">
                                                                <i class="fa-solid fa-info text-white pt-1"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 1" class="badge-success">
                                                                <i class="fa-solid fa-check text-white pt-1"></i>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </ng-container>
                                    </table>
                              
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-6 mb-4 align-items-stretch">
                    <div class="backgroundTable">
                        <div class="row">
                                <div class="col-6 filterDatatable">
                                    <div class="text-white">
                                        <h5 class="form-control-table custom-select-info mt-1">Semana Actual</h5>
                                    </div>
                                </div>
                            </div>
                        <div class="card-body">
                                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"  class="componente-importantes componente-importantes-from-popup">
                                        <ng-container *ngIf="listCurrentWeek == null || listCurrentWeek.length == 0">
                                            <div class="text-center text-white">
                                                <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                                <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="listCurrentWeek != null && listCurrentWeek.length != 0">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">Colaborador</th>
                                                    <th class="text-center">Gestión</th>
                                                    <th class="text-center">Subv</th>
                                                    <th class="text-center">Trabajo en equipo</th>
                                                </tr>
                                            </thead>
                                            <tbody class="align-middle">
                                                <tr>
                                                    <td>{{transformName(listCurrentWeek[0].name)}}</td>
                                                    <td *ngFor="let item of listCurrentWeek">
                                                        <div *ngIf="item.idindicator == 1">
                                                            <span *ngIf="item.value == 3" class="badge-danger">
                                                                <i class="fa-solid fa-xmark text-white pt-1"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 2" class="badge-warning">
                                                                <i class="fa-solid fa-info text-white pt-1"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 1" class="badge-success">
                                                                <i class="fa-solid fa-check text-white pt-1"></i>
                                                            </span>
                                                        </div>
                                                        <div *ngIf="item.idindicator == 2">
                                                            <span *ngIf="item.value == 3" class="badge-danger">
                                                                <i class="fa-solid fa-xmark text-white pt-1"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 2" class="badge-warning">
                                                                <i class="fa-solid fa-info text-white"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 1" class="badge-success">
                                                                <i class="fa-solid fa-check text-white pt-1"></i>
                                                            </span>
                                                        </div>
                                                        <div *ngIf="item.idindicator == 3">
                                                            <span *ngIf="item.value == 3" class="badge-danger">
                                                                <i class="fa-solid fa-xmark text-white pt-1"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 2" class="badge-warning">
                                                                <i class="fa-solid fa-info text-white pt-1"></i>
                                                            </span>
                                                            <span *ngIf="item.value == 1" class="badge-success">
                                                                <i class="fa-solid fa-check text-white pt-1"></i>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </ng-container>
                                    </table>
                            </div>
                    </div>
                </div>
            </div>

            <!--Tabla avance semanal -->
            <div class="row mt-5">
                <div class="row justify-content-between">
                    <div class="col-6 col-xl-6">
                        <h5 class="text-white mt-1 mb-3 h4">Avance Semanal</h5>
                    </div>
                    <div class="col-6 col-xl-6 text-end">

                        <button  class="badge rounded-pill btn btn-outline-light" (click)="weeklyCreat(id)" style="font-size: 14px;">
                            <i class="fa-solid fa-file-pen m-1"></i>
                            <span class="m-1">Crear avance semanal</span>
                        </button>

                    </div>
                </div>
                <div class="col-12 col-xl-12 mb-4">
                    <div class="backgroundTable">
                         <div class="col-12 filterDatatable">
                                  <div class="col-md-6 text-left text-white">
                                     <h6 class="form-control-table custom-select-info">Listado de los avances del proyecto</h6>
                                </div>
                            </div>
                        <div class="text-center">
                            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                                class="componente-importantes componente-importantes-from-popup">
                                <ng-container *ngIf="listProgress ==  null || listProgress.length == 0">
                                    <div class="text-center text-white">
                                        <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                        <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="listProgress != null && listProgress.length != 0">
                                <thead>
                                    <tr>
                                        <th class="text-center">Real</th>
                                        <th class="text-center">Planificado</th>
                                        <th class="text-center">Desviación</th>
                                        <th class="text-center">Fecha de evaluación</th>
                                        <th class="text-center">Fecha planificada</th>
                                        <th class="text-center">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of listProgress">
                                        <td style="font-size: 14px !important;">{{item.percentReal}}%</td>
                                        <td style="font-size: 14px !important;">{{item.percentPlanned}}%</td>
                                        <td style="font-size: 14px !important;">{{item.total}}</td>
                                        <td class="text-center">
                                            <div class="d-flex justify-content-center bd-highlight mb-2">
                                                <div class="p-2 bd-highlight">
                                                    <span
                                                        class="badge rounded-pill text-bg-info text-white font-size-12 p-2" style="width: 6rem !important;">{{item.dateStart}}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="d-flex justify-content-center bd-highlight mb-2">
                                                <div class="p-2 bd-highlight">
                                                    <span
                                                        class="badge rounded-pill text-bg-orange font-size-12 p-2" style="width: 6rem !important;" >{{item.dateEnd}}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div ngbDropdown class="d-inline-block">
                                                <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle></i>
                                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                                    <button (click)="weeklyEdit(item , id)" ngbDropdownItem>
                                                        Editar
                                                    </button>
                                                    <button (click)="weeklyDelete(item.id)"  ngbDropdownItem>Eliminar</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </ng-container>
                            </table>

                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-5">
                <!--Etapas del proyecto -->
                <div class="row justify-content-between">
                    <div class="col-6 col-xl-6">
                        <h5 class="text-white mt-1 mb-3 h4">Etapas del proyecto</h5>
                    </div>
                    <div class="col-6 col-xl-6 text-end">
                        <button (click)="projectStage()" class="badge rounded-pill btn btn-outline-light"  style="font-size: 14px;">
                            <i class="fa-solid fa-note-sticky m-1"></i>
                            <span class="m-1">Administrar etapas</span>
                        </button>
                    </div>
                </div>
                <ng-container *ngIf="listStages == null || listStages.length == 0">
                    <div class="text-center text-white">
                        <h2 class="text-white px-5 mt-5">Sin Etapas</h2>
                        <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                    </div>
                </ng-container>
                <ng-container *ngIf="listStages != null && listStages.length != 0">
                    <div class="col-md-6 col-lg-3 mb-4" *ngFor="let item of listStages">
                        <div class="card border-0 rounded-2  text-white color-grafi-list">
                            <div class="card-body">
                                <div class="card-innerBody d-flex align-items-center">
                                    <div class="card-icon text-light">
                                        <i class="fa-solid fa-note-sticky" [ngStyle]="{ 'color': item.color }"></i>
                                    </div>
                                    <div class="ms-auto">
                                        <p *ngIf="item.state == 0" class="card-label text-end text-muted">No iniciado
                                        </p>
                                        <p *ngIf="item.state == 1" class="card-label text-end text-muted">En Curso</p>
                                        <p *ngIf="item.state == 2" class="card-label text-end text-muted">Finalizado</p>
                                        <p *ngIf="item.name" class="card-label text-end text-muted">{{item.name}}</p>
                                        <p *ngIf="!item.name" class="card-label text-end text-muted">Sin datos</p>


                                    </div>
                                </div>
                                <div class="card-footer d-md-flex text-lightning font-size-10 justify-content-between">
                                    <p class="badge rounded-pill bg-dark border font-size-12 me-1">
                                        <i class="fa-solid fa-calendar"></i>
                                        {{item.dateStart}}
                                    </p>
                                    <p class="badge rounded-pill bg-dark border font-size-12">
                                        <i class="fa-solid fa-calendar"></i>
                                        {{item.dateEnd}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!--Tabla listado de riesgos -->
            <div class="row mt-5">
                <div class="row justify-content-between">
                    <div class="col-6 col-xl-6">
                        <h5 class="text-white mt-1 mb-3 h4">Riesgos </h5>
                    </div>
                    <div class="col-6 col-xl-6 text-end">
                        <button  class="badge rounded-pill btn btn-outline-light" (click)="riskCreate(id)" style="font-size: 14px;">
                            <i class="fa-solid fa-triangle-exclamation m-1"></i>
                            <span class="m-1">Crear riesgo</span>
                        </button>
                    </div>
                </div>
                <div class="col-12 col-xl-12 align-items-stretch">
                    <div class="backgroundTable text-white">
                        <div class="col-12 filterDatatable">
                                <div class="col-md-6 text-left text-white">
                                     <h6 class="form-control-table custom-select-info">Listado de los riesgos del proyecto</h6>
                                </div>
                        </div>
                        <div class="card-body text-center">
                            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                                class="componente-importantes componente-importantes-from-popup text-center">
                                <ng-container *ngIf="listRisksMatrix == null || listRisksMatrix.length == 0">
                                    <div class="text-center text-white">
                                        <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                        <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="listRisksMatrix != null && listRisksMatrix.length !=0">
                                    <thead>
                                        <tr>
                                            <th class="text-center">Riesgo</th>
                                            <th class="text-center">Estado</th>
                                            <th class="text-center">Fecha de activación</th>
                                            <th class="text-center">Fecha Deadline</th>
                                            <th class="text-center">Mitigación</th>
                                            <th class="text-center">Criticidad</th>
                                            <th class="text-center">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of listRisksMatrix">
                                            <td>{{item.name}}</td>
                                            <td>
                                                <span *ngIf="item.status == 1"
                                                    class="badge rounded-pill text-bg-success font-size-12 p-2" style="width: 6rem !important;">Activo</span>
                                                <span *ngIf="item.status == 2"
                                                    class="badge rounded-pill text-bg-warning font-size-12 p-2" style="width: 6rem !important;">No
                                                    activo</span>
                                                <span *ngIf="item.status == 3"
                                                    class="badge rounded-pill text-bg-danger font-size-12 p-2" style="width: 6rem !important;">Issue</span>
                                            </td>
                                            <td>
                                                <div class="d-flex justify-content-center bd-highlight">
                                                <div class="p-2 bd-highlight">
                                                    <span
                                                        class="badge rounded-pill text-bg-info text-white font-size-12 p-2" style="width: 6rem !important;" >{{item.dateStart}}</span>
                                                </div>
                                            </div></td>
                                            <td>
                                                <div class="d-flex justify-content-center bd-highlight">
                                                <div class="p-2 bd-highlight">
                                                    <span
                                                        class="badge rounded-pill text-bg-orange font-size-12 p-2" style="width: 6rem !important;" >{{item.dateEnd}}
                                                    </span>
                                                </div>
                                            </div></td>
                                            <td>
                                                <span *ngIf="!isValid(item.type)"
                                                    class="badge rounded-pill text-bg-primary font-size-12 p-2" style="width: 6rem !important;" >{{item.type}}</span>
                                                <span *ngIf="isValid(item.type)">Sin datos</span>
                                            </td>
                                            <td class="">
                                                <span class="text-warning" style="font-size: 14px;">{{item.process}}%</span>
                                            </td>
                                            <td>
                                                <div ngbDropdown class="d-inline-block">
                                                    <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle
                                                    ></i>
                                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                                        <button (click)="riskEdit(id, item)" ngbDropdownItem>
                                                            Editar
                                                        </button>
                                                      <button ngbDropdownItem
                                                      [routerLink]="['/pdg/project', id, item.id,'risk','mitigations']">
                                                      Mitigaciones</button>
                                                      <button (click)="riskStatus(item.id, 1)" ngbDropdownItem name="1" *ngIf="item.status!=1">Activar</button>
                                                      <button (click)="riskStatus(item.id, 2)" ngbDropdownItem name="2" *ngIf="item.status!=2">Desactivar</button>
                                                      <button (click)="riskStatus(item.id, 3)" ngbDropdownItem name="3" *ngIf="item.status!=3">Issue</button>
                                                      <button (click)="riskDelete(item.id)" ngbDropdownItem>Eliminar</button>
                                                    </div>
                                                  </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </ng-container>
                            </table>

                        </div>
                    </div>
                </div>
            </div>

            <!--Tabla listado de Hitos -->
            <div class="row mt-5">
                <div class="row justify-content-between">
                    <div class="col-6 col-xl-6">
                        <h5 class="text-white mt-1 mb-3 h4">Listado de Hitos</h5>
                    </div>
                    <div class="col-6 col-xl-6 text-end">
                        <button (click)="crearHito()" class="badge rounded-pill btn btn-outline-light "  style="font-size: 14px;">
                            <i class="fa-solid fa-plus m-1"></i>
                            <span class="m-1">Crear Hito</span>
                        </button>
                    </div>
                </div>
                <div class="col-12 col-xl-12 mb-4 align-items-stretch">
                    <div class="backgroundTable text-white">
                        <div class="col-12 filterDatatable">
                                <div class="col-md-6 text-left text-white">
                                     <h6 class="form-control-table custom-select-info">Listado de hitos del proyecto</h6>
                                </div>
                        </div>
                        <div class="card-body text-center">
                            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                                class="componente-importantes componente-importantes-from-popup">
                                <ng-container *ngIf="listMilestones == null || listMilestones.length == 0">
                                    <div class="text-center text-white">
                                        <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                        <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="listMilestones != null && listMilestones.length !=0">

                                    <thead>
                                        <tr>
                                            <th class="text-center">Hito</th>
                                            <th class="text-center">Avance</th>
                                            <th class="text-center">Fecha de inicio</th>
                                            <th class="text-center">Fecha fin</th>
                                            <th class="text-center">Sprint</th>
                                            <th class="text-center">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of listMilestones">
                                            <td>{{item.name}}</td>
                                            <td>
                                                <span *ngIf="item.state == 1"
                                                    class="badge rounded-pill text-bg-gray text-bg-success font-size-12 p-2" style="width: 8rem !important;"  >Creado</span>
                                                <span *ngIf="item.state == 2"
                                                    class="badge rounded-pill text-bg-warning font-size-12 p-2" style="width: 8rem !important;"  >En Curso</span>
                                                <span *ngIf="item.state == 3"
                                                    class="badge rounded-pill text-bg-blue-grey font-size-12 p-2" style="width: 8rem !important;"  >Finalizado</span>
                                            </td>
                                            <td style="font-size: 14px !important;">
                                                <span
                                                class="badge rounded-pill text-bg-info text-white font-size-12 p-2" style="width: 6rem !important;" >{{item.dateStart}}</span>
                                            </td>
                                            <td style="font-size: 14px !important;">
                                                <span
                                                class="badge rounded-pill text-bg-orange font-size-12 p-2" style="width: 6rem !important;" >{{item.dateEnd}}
                                            </span>
                                            </td>
                                            <td style="font-size: 14px !important;">
                                                <span *ngIf="item.sprint == 0">Sin Sprint</span>
                                                <span *ngIf="item.sprint != 0">{{item.sprint}}</span>
                                            </td>
                                            <td class="text-center">
                                                <div ngbDropdown class="d-inline-block">
                                                    <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle></i>
                                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">

                                                        <button (click)="milestoneEdit(id, item)" ngbDropdownItem>
                                                            Editar
                                                        </button>
                                                        <button (click)="stageDeleteMilestone(item.id)" ngbDropdownItem>Eliminar</button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </ng-container>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>